
    /**
     * @description
     *  Modelo de un producto de campaña de reemplazo.
     *
     * @see gigot-backend/Models/Products/CampaignProduct.cs
     */

export class CampaignProductReplacement {

	public campaignProductId: number;
	public id: number;
	public priority: number;
	public replacementId: number;

    /**
     * @description
     *	Construye un producto de campaña de reemplazo con una semántica vacía.
	 *	Nótese que no es lo mismo que construir un producto con valores por
	 *	defecto. Las reglas generales de construcción son:
     *
     *      - Campos 'array' se definen como [].
     *      - Campos 'boolean' se definen como 'false'.
     *      - Campos 'Date' se definen como 'undefined'.
     *      - Campos 'enum' se definen como 'undefined'.
     *      - Campos 'number' se definen como 'undefined'.
     *      - Campos 'string' se definen como '' (cadena vacía).
     *      - Campos 'object' se definen llamando a su propio método #empty().
     *      - Campos de la superclase se definen al igual que campos 'object'.
     *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
     *
     * @returns
     *	Un producto de campaña de reemplazo vacío.
     */
    public static empty(): CampaignProductReplacement {
        const campaignProductReplacement: CampaignProductReplacement = new CampaignProductReplacement();
		campaignProductReplacement.campaignProductId = undefined;
		campaignProductReplacement.id = undefined;
		campaignProductReplacement.priority = undefined;
		campaignProductReplacement.replacementId = undefined;
        return campaignProductReplacement;
    }

	/**
     * @description
     *  Método de reificación de un modelo compatible anémico. Esto permite
     *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
     *  valor de sus propiedades se mantiene.
     *
     * @param anemicCampaignProductReplacement
     *  El modelo anémico a reificar.
     *
     * @returns
     *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
     *  profundidad desde el modelo anémico.
     */
    public static from(anemicCampaignProductReplacement: CampaignProductReplacement): CampaignProductReplacement {
		if (!anemicCampaignProductReplacement) return undefined;
        const campaignProductReplacement: CampaignProductReplacement = CampaignProductReplacement.empty();
		campaignProductReplacement.campaignProductId = anemicCampaignProductReplacement.campaignProductId;
		campaignProductReplacement.id = anemicCampaignProductReplacement.id;
		campaignProductReplacement.priority = anemicCampaignProductReplacement.priority;
		campaignProductReplacement.replacementId = anemicCampaignProductReplacement.replacementId;
        return campaignProductReplacement;
    }
}
